export function normalizeResizeSizes(values) {
  const sizes = [];
  const seen = new Set();

  for (const value of Array.isArray(values) ? values : []) {
    const width = Number(value?.width);
    const height = Number(value?.height);
    const key = `${width}x${height}`;
    if (!Number.isInteger(width) || !Number.isInteger(height)
      || width < 1 || height < 1 || width > 10000 || height > 10000 || seen.has(key)) continue;
    seen.add(key);
    sizes.push({ width, height });
  }

  return sizes;
}

export function normalizeResizeHints({ hint, orientation_hints: orientationHints } = {}) {
  const clean = value => typeof value === 'string' ? value.trim().slice(0, 1000) : '';
  return {
    resizeHint: clean(hint),
    orientationHints: {
      vertical: clean(orientationHints?.vertical),
      horizontal: clean(orientationHints?.horizontal),
      square: clean(orientationHints?.square),
    },
  };
}

export function mergeResizeSizes(aiSizes, selectedSizes = []) {
  const sizes = [];
  const seenSelections = new Set();

  for (const selected of selectedSizes) {
    const [size] = normalizeResizeSizes([selected]);
    if (!size) continue;
    const key = selected.template?.id ? `template:${selected.template.id}` : `${size.width}x${size.height}`;
    if (seenSelections.has(key)) continue;
    seenSelections.add(key);
    if (selected.template) {
      const plainIndex = sizes.findIndex(existing => !existing.template
        && existing.width === size.width && existing.height === size.height);
      if (plainIndex !== -1) sizes.splice(plainIndex, 1);
    } else if (sizes.some(existing => existing.template
      && existing.width === size.width && existing.height === size.height)) {
      continue;
    }
    sizes.push(selected.template ? { ...size, template: selected.template } : size);
  }

  for (const size of normalizeResizeSizes(aiSizes)) {
    if (!sizes.some(selected => selected.width === size.width && selected.height === size.height)) {
      sizes.push(size);
    }
  }

  return sizes;
}
